import React, { useEffect, useState } from "react";
import styles from "./UserProfile.module.css";
import {
  Briefcase,
  Phone,
  Mail,
  Globe,
  MapPin,
  Home,
  Flag,
  Award,
  FileText,
  Hash,
  CreditCard,
} from "react-feather";
import {
  useGetProfileDdetailQuery,
  useGetUserInquiryListQuery,
} from "../../store/api/profileApi";
import InquireyDetails from "./InquireyDetails";
import UserDetails from "./UserDetails";
import Loader from "../../components/common/Loader";
import { useNavigate } from "react-router-dom";
import ModalPopup from "../../components/ModelPopup";
import { FaEdit } from "react-icons/fa";

const TABS = [{ label: "Inquiry Summary" }, { label: "Account Detail" }];

const UserProfile = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState(0);
  const {
    data: profileData,
    isLoading: profileDataLoading,
    isFetching: profileDataFetching,
  } = useGetProfileDdetailQuery();

  return (
    <div className={styles.mainContainer}>
      {profileDataLoading && <Loader />}
      <div className={styles.ownerDetailContainer}>
        <div className={styles.ownerAvatarCard}>
          <div className={styles.avatarOwnerWrapper}>
            <img
              src={
                "https://cdn.pixabay.com/photo/2015/03/04/22/35/avatar-659652_1280.png"
              }
              alt="Owner Avatar"
              className={styles.ownerAvatar}
            />
            <div className={styles.ownerName}>{profileData?.owner_name}</div>
          </div>
        </div>
        <div className={styles.horizontalDivider} />
        <div className={styles.mobileRow}>
          <div className={styles.infoCard}>
            <span className={styles.infoIcon}>
              <Phone />
            </span>
            <div className={styles.infoCol}>
              <span className={styles.infoLabel}>Phone</span>
              <div className={styles.infoValue}>{profileData?.owner_phone}</div>
            </div>
          </div>
          <div className={styles.infoCard}>
            <span className={styles.infoIcon}>
              <Mail />
            </span>
            <div className={styles.infoCol}>
              <span className={styles.infoLabel}>Email</span>
              <div className={styles.infoValue}>{profileData?.owner_email}</div>
            </div>
          </div>
        </div>
      </div>
      {/* Horizontal Tab Bar */}
      <div className={`${styles.tabContainer} position-relative`}>
        <div className={styles.tabBar}>
          {TABS.map((tab, idx) => (
            <button
              key={tab.label}
              className={`${styles.tabButton} ${
                activeTab === idx ? styles.activeTab : ""
              }`}
              onClick={() => setActiveTab(idx)}
              type="button"
            >
              {tab.label}
            </button>
          ))}
        </div>
        <div
          className="d-flex align-items-center gap-2 position-absolute top-0 end-0 z-2 text-primary cursor-pointer"
          onClick={() => navigate("/profile/edit")}
        >
          <FaEdit /> Edit Profile
        </div>
        {/* Owner Detail Section */}
        <div className={styles.userProfileContainer}>
          <div className={styles.profileMain}>
            {/* Tab Content */}
            <div className={styles.tabContent}>
              {activeTab === 0 && <InquireyDetails />}
              {activeTab === 1 && (
                <UserDetails
                  profileData={profileData}
                  loadingProfileData={profileDataFetching || profileDataLoading}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserProfile;
